export function getCountOfGivenData(data) {
  return data ? data : 0;
}
